(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.controller('EmailOverviewController', ['emails', EmailOverviewControllerFn]);

    /* controlle for email-overview */
    function EmailOverviewControllerFn(emails) {
        var vm = this;
        
        vm.emails = [];

        activate();

        /* activation work */
        function activate() {
            vm.emails = emails;
        }
    }
})();
